// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"16ad7c2d","14":"195c41a7","38":"ffb07d6f","134":"9f918883","449":"4be4d6d9","617":"6648d499","659":"d698e8a7","758":"43bfcb4c","778":"e9deb0a5","912":"f9b5f4d9"}[chunkId] + ".chunk.js";
};